import React, { useEffect, useState } from 'react'
import { VertButton, VertTypography } from "@vertem-core/vertice-ds";
import ShowCaseTimer from "../../ShowCaseTimer/ShowCaseTimer";
import { pointsMask } from "Utils/commons/points";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchAvailability } from "Services/Apis/Availability";
import { FETCH_AVAILABILITY_SUCCESS } from "../../../redux/Reducers/Availability/AvailabilityReducer";
import * as availabilityService from '../../../Services/Apis/AvailabilityGeneric/index';

const Unavailable = () => {
    return (
        <div className="buttons-wrapper">
            <VertButton type="default" disabled>
                PRODUTO INDISPONÍVEL
            </VertButton>
        </div>
    )
}

const Loading = () => (
    <div className="buttons-wrapper">
        <VertButton loading disabled type="default" />
    </div>
)

let callWasMaked = false
const ProductDetailAvailability = ({
    regularPointsValue,
    pointValue,
    isAvailable: available,
    originalId = null,
    vendorId = null,
    isAvailableGeneric
}) => {
    const [isAvailable, setIsAvailable] = useState(null)
    const [product, setProduct] = useState(null)
    const Dispatch = useDispatch()
    const { sku } = useParams();
    const Oidc = useSelector(({ oidc: data }) => data);
    const Catalog = useSelector(({ Catalog: data }) => data);
    const Products = useSelector(({ Products }) => Products);
    const Availability = useSelector(({ Availability }) => Availability);
    const [availabilityGenericAlreadySearched, setAvailabilityGenericAlreadySearched] = useState(false);
    const [previousSku, setPreviousSku] = useState(null);
    const [regularPointsValueGeneric, setRegularPointsValueGeneric] = useState(null);
    const [pointValueGeneric, setPointValueGeneric] = useState(null);

    const {
        currencyConfiguration: { decimalPlaces, pointsName },
    } = Catalog;

    const isPgs = () => {
        return sku.includes('-PGS');
    }

    const CallAvailability = async () => {
        if (Availability[sku] || callWasMaked) return;
        callWasMaked = true;

        if (!product.skus.some(({ sku: s }) => s === sku)) return;

        const result = await fetchAvailability(
            Oidc.user, sku,
            product.skus.filter(({ sku: s }) => s === sku)[0].originalId,
            product.vendor.id
        )
        Dispatch({
            type: FETCH_AVAILABILITY_SUCCESS,
            payload: {
                response: [{
                    response: result,
                    sku
                }],
            }
        })
    }

    const CallAvailabilityGeneric = async () => {
        setAvailabilityGenericAlreadySearched(true);
        availabilityService.getAvailabilityGeneric(
            Oidc.user,
            sku,
            originalId,
            vendorId).then(e => {
                if (e === null) return;

                if (!e.data.length) return;

                const { available, price, regularPrice } = e.data[0];
                setIsAvailable(available);
                setPointValueGeneric(price);
                setRegularPointsValueGeneric(regularPrice);
                isAvailableGeneric(available);
            })
    }

    useEffect(() => {
        if (available !== null && isAvailable === null && Catalog) {
            setIsAvailable(available);
        }
    }, [available, isAvailable, Catalog]);

    useEffect(() => {
        if (Products.isLoaded) {
            const productCached = Products.products.filter((p) => {
                const skuSelected = p.skus.filter((s) => s.sku === sku)[0];
                return skuSelected || false;
            });
            if (callWasMaked) callWasMaked = false;
            productCached[0] && setProduct(productCached[0]);
        }
    }, [Products, sku]);

    if (sku && Availability && !Availability[sku] && product && !callWasMaked && Oidc && Oidc.user && !isPgs()) {
        CallAvailability()
    }
    if (sku && isPgs() && !availabilityGenericAlreadySearched) {
        CallAvailabilityGeneric();
    }

    const formattedItemValue = pointsMask(isPgs() ? pointValueGeneric : pointValue, decimalPlaces, pointsName);
    const formattedRegularItemValue = pointsMask(
        isPgs() ? regularPointsValueGeneric : regularPointsValue,
        decimalPlaces,
        pointsName
    );

    useEffect(() => {
        return () => {
            setAvailabilityGenericAlreadySearched(false);
        }
    }, []);

    useEffect(() => {
        if (sku != previousSku) {
            setAvailabilityGenericAlreadySearched(false);
            setPreviousSku(sku);
        }
    }, [sku]);

    useEffect(() => {
        if (previousSku && isPgs()) {
            CallAvailabilityGeneric();
        }
    }, [previousSku]);

    return (
        <>
            {
                (!isPgs() && (isAvailable === null || !Catalog || !Products)) ?
                    <>
                        <Loading />
                    </>
                    :
                    <>
                        {
                            (!isPgs() && (isAvailable === false)) ?
                                <>
                                    <Unavailable />
                                </>
                                :
                                <div className="redemption-by-points">
                                    <VertTypography.Title className="redemption-label">
                                        Resgate por
                                    </VertTypography.Title>
                                    {formattedRegularItemValue.value !== formattedItemValue.value && (
                                        <VertTypography.Text className="redemption-regular-value">
                                            {formattedRegularItemValue.value} {formattedItemValue.label}
                                        </VertTypography.Text>
                                    )}

                                    <VertTypography.Paragraph className="redemption-value">
                                        {formattedItemValue.value}{' '}
                                        <span>{formattedItemValue.label}</span>
                                    </VertTypography.Paragraph>

                                    <div className="showcase-timer">
                                        <ShowCaseTimer
                                            Sku={sku}
                                            label={
                                                <VertTypography.Paragraph>
                                                    Oferta expira em:
                                                </VertTypography.Paragraph>
                                            }
                                        />
                                    </div>
                                </div>
                        }
                    </>
            }
        </>
    )
}

export default ProductDetailAvailability
